import React, {useEffect, useRef, useState} from 'react';
import AsyncSelect from 'react-select/async';
import './style.less';
import {Form} from "react-bootstrap";
import classNames from "classnames";
import {GREEN_COLOR_JS, INVALID_CLASS_SELECT, INVALID_FEEDBACK_COLOR} from "../../utils/consts";
import FakeRequiredInput from "../common/FakeRequiredInput";
import uuid from "react-uuid";
import {makeUID} from "../../helpers";

const RefSelectInput = React.forwardRef((props,ref) => {
    return <div ref={ref} id={`react-select-wrapper-${props?.refKey ?? makeUID(5)}`}>
        <AsyncSelect
            {...props}
        />
    </div>
})

function SelectInput({
  noOptionsMessage, loadingMessage, isClearable, value, cacheOptions, placeholder, defaultOptions, defaultValue, loadOptions, onInputChange, onChange, classNamePrefix, components, disabled = false,
    ...rest
}) {
    const {required,selectKey} = {...rest}
    const ref = useRef(null)

    const classNameBase = classNames(classNamePrefix,'selector_input_base')
    const classNameInvalid = classNames(classNamePrefix,'selector_input_base',INVALID_CLASS_SELECT)
    const [isValid,setIsValid] = useState(true)

  const baseAsyncSelect = (
      <RefSelectInput
          refKey={selectKey}
          ref={ref}
          isMulti={rest.isMulti}
          isDisabled={disabled}
          noOptionsMessage={noOptionsMessage ?? (() => 'Ничего не найдено')}
          loadingMessage={loadingMessage ?? (() => 'Поиск...')}
          isClearable={isClearable ?? false}
          // classNamePrefix={`${classNamePrefix ?? ''} selector_input_base`}
          classNamePrefix={isValid ? classNameBase : classNameInvalid}
          cacheOptions={cacheOptions ?? false}
          components={components ?? {}}
          value={value}
          placeholder={placeholder ?? ''}
          // value={value ?? ' 1'}
          defaultOptions={defaultOptions ?? []}
          defaultValue={defaultValue ?? []}
          loadOptions={loadOptions}
          onInputChange={onInputChange}
          onChange={(...e)=>{
              if(required && !e[0]?.length){
                  setIsValid(false)
              } else if (!isValid){
                  setIsValid(true)
              }
              return onChange(...e)
          }}
      />
  )

  return (
   required ? <React.Fragment>
     {baseAsyncSelect}
       <FakeRequiredInput selectRef={ref.current ?? `react-select-wrapper-${selectKey}`} value={value?.length}/>
   </React.Fragment> : baseAsyncSelect
  );
}

export default SelectInput;
